(function () {
    "use strict";

    angular.module('iMatApp')
        .controller('ModelViewerMenuController', ModelViewerMenuController);

    ModelViewerMenuController.$inject = ['$scope', 'modelTabWorkflow', 'modelViewerService', 'eventService', 'mainWorkspace', 'uploadModelConsts', 'googleTagManagerService'];

    function ModelViewerMenuController($scope, modelTabWorkflow, modelViewerService, eventService, mainWorkspace, consts, googleTagManagerService) {
        var vm = this;

        vm.getModelName = getModelName;

        vm.isOpened = false;
        vm.selectedSubMenu = null;

        vm.openMenuItem = openMenuItem;
        vm.commandMenuItem = commandMenuItem;

        vm.is3DViewerSettingsVisible = modelViewerService.is3DModelRendered;
        vm.isAutoRotateEnabled = modelViewerService.autoRotateEnabled;
        vm.isClippingEnabled = isClippingEnabled;
        vm.isGroundPlaneEnabled = isGroundPlaneEnabled;
        vm.toggle = toggle;
        vm.closeMenu = closeMenu;

        // -----------------------------------------------------------------------------------

        function getModelName() {
            var fileName = getFileName();
            return fileName ? removeExtension(fileName) : null;
        }

        function toggle() {
            vm.isOpened = !vm.isOpened;
            vm.selectedSubMenu = null;
        }

        function closeMenu() {
            vm.isOpened = false;
            vm.selectedSubMenu = null;
        }

        function openMenuItem($event, menuItemName) {
            if (vm.selectedSubMenu !== menuItemName) {
                vm.selectedSubMenu = menuItemName;

                eventService.notify(consts.eventNames.menuItemOpened, menuItemName);
                $event.stopPropagation();
            }
        }

        function commandMenuItem($event, commandName) {
            openMenuItem($event, '');

            if (commandName === 'UploadNewModel') {
                trackUploadNewModelEvent();
                modelTabWorkflow.abortAndResetState();
                eventService.notify(consts.eventNames.showBrowseFileDialog);
            }
        }

        function isGroundPlaneEnabled(value) {
            if (angular.isUndefined(value)) {
                return mainWorkspace.options.viewer.groundPlane;
            }

            mainWorkspace.options.viewer.groundPlane = value;
            // temporary fast solution. Will fix onChange event in modelViewerComponent
            mainWorkspace.options.viewer = angular.copy(mainWorkspace.options.viewer);

            return angular.undefined;
        }

        function isClippingEnabled(value) {
            if (angular.isUndefined(value)) {
                return mainWorkspace.options.viewer.clipping;
            }

            mainWorkspace.options.viewer.clipping = value;
            // temporary fast solution. Will fix onChange event in modelViewerComponent
            mainWorkspace.options.viewer = angular.copy(mainWorkspace.options.viewer);

            return angular.undefined;
        }


        // -----------------------------------------------------------------------------------

        function getFileName() {
            if (mainWorkspace.product.model.fileName) {
                return mainWorkspace.product.model.fileName;
            }

            if (mainWorkspace.fileToShowDirectly) {
                return mainWorkspace.fileToShowDirectly.name;
            }

            return null;
        }

        function removeExtension(filename) {
            var lastDotPosition = filename.lastIndexOf(".");
            if (lastDotPosition === -1) {
                return filename;
            } else {
                return filename.substr(0, lastDotPosition);
            }
        }

        function trackUploadNewModelEvent() {
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Tracking] Use Upload Control',
                'eventAction': 'Single Upload Page - Upload Model from Viewer Menu',
                'eventLabel': undefined,
                'eventValue': undefined
            });
        }
    }
})();